/*
 * order structure 
 * @author: Jason Wong
 * @since: 2018-12-07 09:38:44
 */

export default class Order{
    name;data;

    constructor(orderName,data){
        this.name = orderName;
        this.data = data;
    };
}